'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CondoIcon = function (_React$Component) {
    _inherits(CondoIcon, _React$Component);

    function CondoIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CondoIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CondoIcon.__proto__ || Object.getPrototypeOf(CondoIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'Condo-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, transform: 'translate(0.5)', fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_33' },
                    _react2.default.createElement(
                        'g',
                        { id: 'building-nature' },
                        _react2.default.createElement('path', { fill: color, id: 'Shape_93', d: 'M434,253h15a.5.5,0,0,0,.468-.676l-1.257-3.351a1.507,1.507,0,0,0-1.4-.973H436.193a1.508,1.508,0,0,0-1.4.973l-1.261,3.351A.5.5,0,0,0,434,253Z', transform: 'translate(-432 -248)' }),
                        _react2.default.createElement('path', { fill: color, id: 'Shape_94', d: 'M453.061,270h1.469a1,1,0,0,1,0,2H432.98a1,1,0,0,1,0-2h1.714a.248.248,0,0,0,.245-.25v-15.5a.248.248,0,0,1,.245-.25h12.245a.248.248,0,0,1,.245.25v15.5a.248.248,0,0,0,.245.25H451.1a.248.248,0,0,0,.245-.25v-.476a.245.245,0,0,0-.148-.223A2.247,2.247,0,0,1,449.878,267a68.328,68.328,0,0,1,1.734-7.14.507.507,0,0,1,.94,0,68.336,68.336,0,0,1,1.734,7.14,2.244,2.244,0,0,1-1.321,2.051.245.245,0,0,0-.148.223v.476A.248.248,0,0,0,453.061,270Zm-13.224-13.25h-2.449a.75.75,0,0,0,0,1.5h2.449a.75.75,0,0,0,0-1.5ZM436.653,262a.743.743,0,0,1,.735-.75h2.449a.75.75,0,0,1,0,1.5h-2.449A.743.743,0,0,1,436.653,262Zm5.878,8a.248.248,0,0,0,.245-.25V267.5a1.47,1.47,0,1,0-2.939,0v2.25a.248.248,0,0,0,.245.25Zm2.694-7.25h-2.449a.75.75,0,0,1,0-1.5h2.449a.75.75,0,0,1,0,1.5Zm-2.449-4.5h2.449a.75.75,0,0,0,0-1.5h-2.449a.75.75,0,0,0,0,1.5Z', transform: 'translate(-432 -248)', fillRule: 'evenodd' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CondoIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return CondoIcon;
}(_react2.default.Component);

exports.default = CondoIcon;